<template>
    <div>
        <div class="header">
            <span>过往学习/工作经历</span>
            <el-button @click="handleAdd">新增</el-button>
        </div>
        <el-table :data="tableData" border style="width: 100%">
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column prop="startDate" label="开始时间" align="center">
                <template slot-scope="scope">
                    <el-date-picker
v-model="scope.row.startDate" type="date" placeholder="选择日期"
                        value-format="YYYY-MM-DD"
>
                    </el-date-picker>
                </template>
            </el-table-column>
            <el-table-column prop="endDate" label="结束时间" align="center">
                <template slot-scope="scope">
                    <el-date-picker
v-model="scope.row.endDate" type="date" placeholder="选择日期"
                        value-format="YYYY-MM-DD"
>
                    </el-date-picker>
                </template>
            </el-table-column>
            <el-table-column prop="jobTitle" label="工作(学习)名称" align="center">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.jobTitle" placeholder="请输入"></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="" label="删除" align="center" width="100">
                <template slot-scope="scope">
                    <el-button type="text" text @click="delectData(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog
v-if="dialogFormVisible" custom-class="box-dialog" :visible.sync="dialogFormVisible"
            append-to-body="true" width="800px" height="500px" :close-on-click-modal="false"
            :close-on-press-escape="false" :show-close="false" title="工作经历信息表"
>
            <el-form :model="vo" @submit.native.prevent>
                <div style="width:100%;" class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body " style="width:100%;">
                            <tbody>
                                <tr>
                                    <td ref="tdlbl_开始日期" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span v-field-lbl="'startDate'" class="field">开始日期</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="5">
                                        <form-item
ref="startDate"
                                            :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'开始日期','propName':'startDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'startDate','iconName':'rqxzk','model':'vo.startDate','option':[],'formTdAlign':'text-left','weekday':0,'formTdColspan':24}"
                                            :vo="vo" :can-edit="canEdit"
/>
                                    </td>
                                    <td ref="tdlbl_结束日期" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span v-field-lbl="'endDate'" class="field">结束日期</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="5">
                                        <form-item
ref="endDate"
                                            :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'结束日期','propName':'endDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'endDate','iconName':'rqxzk','model':'vo.endDate','option':[],'formTdAlign':'text-left','weekday':0,'formTdColspan':24}"
                                            :vo="vo" :can-edit="canEdit"
/>
                                    </td>
                                </tr>
                                <tr>
                                    <td ref="tdlbl_工作(学习)名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span v-field-lbl="'jobTitle'" class="field">工作(学习)名称</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="11">
                                        <form-item
ref="jobTitle"
                                            :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'工作(学习)名称','propName':'jobTitle','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.jobTitle','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}"
                                            :vo="vo" :can-edit="canEdit"
/>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type=" " icon="el-icon-close" @click="dialogFormVisible=false">关 闭</el-button>
                <el-button type="primary" icon="el-icon-check" @click="handleSubmit">保 存</el-button>
            </div>
        </el-dialog>

        <!-- <inner-table id="innerTableWorkResume" ref="workResumeList" :listviewurl="'teacher.workResume.list'"
            :can-edit="1" :can-delete="1" :link-prop-name="''" /> -->

        <!-- <el-button @click="handleAdd">新增</el-button>
  <inner-table id="innerTable" ref="workResumeList" :listviewurl="'teacher.workResume.list'" :can-edit="1" :can-delete="1" :link-prop-name="''"/> -->

    </div>
</template>

<script>
export default {
    props: {
        list: [],
        vo: {}
    },
    data() {
        return {
            tableData: [],
            form: {
                startDate: '',
                endDate: '',
                jobTitle: ''
            },
            formTitle: '工作经历信息表',
            dialogFormVisible: false,
            busiformBtns: []
        }
    },
    computed: {},
    watch: {},
    created: function() {

    },
    mounted: function() {
        this.getList()
    },
    methods: {
        getList() {
            this.$http({
                method: 'post',
                url: '/xsgl/teacherWorkResume/listdata?urlsearch=teacherId:' + this.vo.teacherId
            }).then(res => {
                if (res.code === 'success') {
                    this.tableData = res.body.pageInfo.list
                }
            })
        },
        handleSubmit() {
            this.vo.startDate = this.vo.startDate ? moment(this.vo.startDate).format('YYYY-MM-DD') : ''
            this.vo.endDate = this.vo.endDate ? moment(this.vo.endDate).format('YYYY-MM-DD') : ''

            if (_this.vo.id) {
                _this.$http({
                    	method: 'put',
                    	url: '/xsgl/teacherWorkResume/update',
                    	data: _this.vo
                }).then(res => {
                    	if (res.code === 'success') {
                    		_this.$message.success(res.message)
                    	} else {
                    		_this.$message.error(res.message)
                    	}
                    _this.dialogFormVisible = false
                    _this.form = {}
                    _this.$bus.emit('refreshListData')
                    this.getList()
                })
            } else {
                let data = {
                    ..._this.vo,
                    teacherBasicInfoId: _this.teacherPara.id,
                    name: _this.teacherPara.name,
                    teacherId: _this.teacherPara.teacherId,
                    jobTitle: _this.teacherPara.jobTitle
                }
                _this.$http({
                    	method: 'post',
                    	url: '/xsgl/teacherWorkResume/insert',
                    	data: data
                }).then(res => {
                    	if (res.code === 'success') {
                    		_this.$message.success(res.message)
                    	} else {
                    		_this.$message.error(res.message)
                    	}
                    _this.dialogFormVisible = false
                    _this.form = {}
                    _this.$bus.emit('refreshListData')
                    this.getList()
                })
            }
        },
        //d32d01a3c4f64dc2a6eebb302f3a5d8f
        handleAdd() {
            this.dialogFormVisible = true
            // this.$http({
            // 	method:'DELETE',
            // 	url:'/xsgl/teacherWorkResume/delete?ids=d32d01a3c4f64dc2a6eebb302f3a5d8f',
            // }).then(res=>{
            // 	if(res.code==='success'){
            // 		this.$message.success(res.message)
            // 	}else{
            // 		this.$message.error(res.message)
            // 	}
            //     this.dialogFormVisible = false;
            //     this.$bus.emit('refreshListData');
            // })
        },
        // 内嵌子表-表头按钮方法
        selectGroup(val) {
            console.log('val', val)
            if (val) {
                this.vo = {
                    ...val
                }
            }
            this.dialogFormVisible = true
        },
        addList: function() {
            let _this = this
            _this.$nextTick(() => {
                _this.tableData.push(_this.form)
            })
        },
        delectData(row) {
            this.$confirm('是否删除该工作信息?', '确认操作', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    method: 'DELETE',
                    url: '/xsgl/teacherWorkResume/delete?ids=' + row.id
                }).then(res => {
                    if (res.code === 'success') {
                        this.getList()
                    }
                })
            }).catch(() => {

            })
        }
    }
}
</script>

<style scoped>
    .header {
        padding: 6px 20px;
        background-color: #f2f5fb;
        font-size: 15px;
        font-weight: 500;
        line-height: 40px;
        display: flex;
        justify-content: space-between;
    }
</style>
